import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useLocation } from "react-router";

export function usePostHogPageview() {
  const location = useLocation();
  const postHog = usePostHog();
  // biome-ignore lint/correctness/useExhaustiveDependencies: capture when location changes
  useEffect(() => {
    postHog.capture("$pageview", { $current_url: window.location.href });
  }, [location, postHog]);
}
